(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function FixCarouselMaxHeight() {
      document.querySelectorAll('.Slideshow__Carousel').forEach(($carousel) => {
        let flickity = Flickity.data($carousel);
        let $viewport = $carousel.querySelector('.flickity-viewport');
        if ($viewport) {
          $viewport.style.maxHeight = `${flickity.maxCellHeight}px`;
        }
      })
    }

    document.addEventListener('DOMContentLoaded', () => {
      FixCarouselMaxHeight();
      setTimeout(FixCarouselMaxHeight, 500);
      setTimeout(FixCarouselMaxHeight, 1000);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
